export default "__VITE_ASSET__BInBvZi8__"